import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Flex, Pagination } from 'antd'
import { useEffect } from 'react'
import {
  getAudiences,
  selectAudiences,
  setAudienceQuery,
} from '../../../../store/AudiencesReducer'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { AudienceCard } from './AudienceCard'

interface Props {
  viewOnly?: boolean
  showOnlySubscribedCount?: boolean
  hideAll?: boolean
  // When set, the list is server-side paginated with this page size and a pager
  // is shown (keeps the campaign audience step compact).
  pageSize?: number
}

export const AudienceList = ({
  viewOnly = false,
  showOnlySubscribedCount = false,
  hideAll = false,
  pageSize,
}: Props) => {
  const dispatch = useAppDispatch()
  const audiences = useAppSelector(selectAudiences())
  const { query } = useAppSelector((state) => state.audiences)

  const fetchAudiences = (current: number) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current,
        ...(pageSize !== undefined ? { pageSize } : {}),
      },
    }

    dispatch(setAudienceQuery(newQuery))
    dispatch(getAudiences(newQuery))
  }

  useEffect(() => {
    fetchAudiences(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, pageSize])

  return (
    <>
      {audiences
        .filter((audience) => !(hideAll && audience.slug === 'all'))
        .map((audience) => (
          <AudienceCard
            key={audience.id}
            audience={audience}
            viewOnly={viewOnly}
            showOnlySubscribedCount={showOnlySubscribedCount}
          />
        ))}
      {pageSize !== undefined && (query.pagination?.total ?? 0) > pageSize && (
        <Flex justify="center">
          <Pagination
            size="small"
            current={query.pagination?.current}
            pageSize={query.pagination?.pageSize}
            total={query.pagination?.total}
            onChange={(value) => fetchAudiences(value)}
          />
        </Flex>
      )}
    </>
  )
}
